/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContractType = {
    FixedPrice: 'FIXED_PRICE',
    TimeAndMaterials: 'TIME_AND_MATERIALS'
} as const;
export type ContractType = typeof ContractType[keyof typeof ContractType];


export function instanceOfContractType(value: any): boolean {
    for (const key in ContractType) {
        if (Object.prototype.hasOwnProperty.call(ContractType, key)) {
            // @ts-ignore
            if (ContractType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContractTypeFromJSON(json: any): ContractType {
    return ContractTypeFromJSONTyped(json, false);
}

export function ContractTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractType {
    return json as ContractType;
}

export function ContractTypeToJSON(value?: ContractType | null): any {
    return value as any;
}

